import styles from "./QuantityModifierAddonGroupForm.module.scss";
import QuantityModifier from "../support/QuantityModifier";
import BodyText from "../support/BodyText";

export default function QuantityModifierAddonGroup() {
  return (
    <>
      <div className={styles.container}>
        <BodyText>Ingredient Name</BodyText>
        <div className={styles.leftContainer}>
          <QuantityModifier initialValue={1} min={0} max={10} />
          <BodyText className={styles.priceText}>80 kr</BodyText>
        </div>
      </div>
      <div className={styles.container}>
        <BodyText>Ingredient Name</BodyText>
        <div className={styles.leftContainer}>
          <QuantityModifier initialValue={0} min={0} max={10} />
          <BodyText className={styles.priceText}>100 kr</BodyText>
        </div>
      </div>
    </>
  );
}
